<template>
  <el-dialog
      :title="$t('socialPosts.create.publishNow.title')"
      :visible.sync="modalConfirmPublishNow"
      v-loading="loadingStatus"
      width="45%"
      @close="closeModal">
        <span class="text-left">
          {{ $t('socialPosts.create.publishNow.text') }}
        </span>
    <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="confirm()">{{ $t('socialPosts.create.publishNow.confirm') }}</el-button>
          <el-button @click="closeModal()">{{ $t('socialPosts.create.publishNow.cancel') }}</el-button>
        </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'DialogPublishNow',
  computed: {
    ...mapState('socialPostsCreationPostEditorial', [
      'modalConfirmPublishNow',
      'loadingStatus']),
    ...mapGetters('socialPostsCreationPostEditorial',
      ['getModalConfirmPublishNow'])
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setModalConfirmPublishNow']),
    ...mapActions('socialPostsCreationPostEditorial',
      ['handlePublish', 'validatePost']),
    confirm () {
      this.handlePublish()
    },
    closeModal () {
      this.setModalConfirmPublishNow(false)
    }
  }
}
</script>

<style>

</style>
